import { render, staticRenderFns } from "./editSpecialAct.vue?vue&type=template&id=fbbdab18&scoped=true&"
import script from "./editSpecialAct.vue?vue&type=script&lang=js&"
export * from "./editSpecialAct.vue?vue&type=script&lang=js&"
import style0 from "./editSpecialAct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./editSpecialAct.vue?vue&type=style&index=1&id=fbbdab18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbdab18",
  null
  
)

component.options.__file = "editSpecialAct.vue"
export default component.exports